export type Sizes = {
  zero?: number
  xs: number
  sm: number
  md: number
  lg: number
  xlg?: number
  '1x': number
  '2x': number
  '3x': number
  '4x': number
  '5x'?: number
  '6x'?: number
  '7x'?: number
  auto: string
}

export const fontSizes: Sizes = {
  zero: 0,
  xs: 10,
  sm: 12,
  md: 14,
  lg: 16,
  '1x': 20,
  '2x': 24,
  '3x': 30,
  '4x': 40,
  '5x': 50,
  '6x': 60,
  '7x': 64,
  auto: 'auto',
}
export const spacing: Sizes = {
  zero: 0,
  xs: 4,
  sm: 8,
  md: 12,
  lg: 16,
  '1x': 20,
  '2x': 24,
  '3x': 30,
  '4x': 40,
  '5x': 50,
  '6x': 60,
  '7x': 70,
  auto: 'auto',
}

export const colors: any = {
  primary: '#0071BD',
  primary600: '#008955',
  primary50: '#EBF8FF',
  secondary: '#0071BD4D',
  primaryText: '#333333',
  textColor: '#000000',
  text100: '#5C5C5C',
  borderColor: '#B9B9B9',
  white: '#FFFFFF',
  greenLight: '#E7F8F2',
  greenNormal: '#10B981',
  greenBackground: '#EFF6F1',
  yellowLight: '#FFF5D9',
  yellowNormal: '#FFBB38',
  redLight: '#FFE0E1',
  cyanLight: '#DCFAF8',
  cyanNormal: '#16DBCC',
  blueLight: '#E7F6FD',
  blueNormal: '#0EA5E9',
  pending: 'rgba(255, 27, 19, 0.5)',
  tabGreenLight: '#DBF5EC',
  tabGreenNormal: '#10B981',
  danger: '#FD5F72',
  success: '#0CAE4A',
  black: '#000000',
  black500: '#1E1E1E',
  grey300: '#B9B9B9',
  grey100: '#E9E9E9',
  grey200: '#EBEBEB',
  green800: '#32583D',
  red100: '#FDEAEA',
  blue100: '#7ECAEC99',
  yellow100: '#FFE8C3',
  transparent: '#FFFFFF00',
  violet100: '#E0E3F6',
  purple: '#44238B',
  red: '#FF0E60',
  adminBg: '#f8f8ff',
  red800: '#E11D48',
  red200: 'rgba(225, 29, 72, 0.1)',
  green500: '#10B981',
  green200: 'rgba(16, 185, 129, 0.1)',
  tabBg: '#FCFCFC',
  inputBorder: '#E9E9E9',
  greyText: '#A8A6AC',
  orange: '#FF5500',
  orangeLight: '#FFF5E6',
  reserved: 'rgba(249, 223, 30, 0.1)',
  unavailable: 'rgba(255, 224, 225, 1)',
  redNormal: '#E11D48',
  borderBlue: '#004AAD80',
  red300: '#D33838',
  green100: '#D1FAEC',
  green600: '#065F42',
  purple600: '#581478',
  purple100: '#EAD6F3',
  red400: '#FFE0E1',
  red600: '#FF0E60',
  green400: '#6EE7BF',
  cyan100: '#DAFFDC',
  grey400: '#6C757D',
}

export const fontFamily: any = {
  primary: 'Poppins',
  secondary: 'Montserrat',
}

export const fontWeight: Sizes = {
  xs: 100,
  sm: 200,
  md: 300,
  lg: 400,
  xlg: 500,
  '1x': 600,
  '2x': 700,
  '3x': 800,
  '4x': 900,
  '5x': 0,
  auto: 'auto',
}

export const createTheme = () => {
  const theme = {
    colors: colors,
    fontSizes,
    spacing,
    fontFamily,
    fontWeight,
  }

  return theme
}

const theme = createTheme()
export default theme
